import type { Dispatch, AnyAction } from 'redux';

import type ToolTypeVM from 'ab-viewModels/toolType/toolType.viewModel';

import type ToolTypeRM from 'ab-requestModels/toolType/toolType.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function create(form: ToolTypeRM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post<ToolTypeVM>(API.V1.RESOURCES.TOOL_TYPE.CREATE, form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findList() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<ToolTypeVM[]>(API.V1.RESOURCES.TOOL_TYPE.FIND_LIST);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
